import { Language } from './types';

const urlParams = new URLSearchParams(window.location.search);
const FORCE_STAGING = urlParams.get('staging') === 'true';

const STAGING_MODE = FORCE_STAGING || window.location.hostname.includes('staging');

const STAGING_ENDPOINT = 'https://api.staging-lawfty.com';
const PRODUCTION_ENDPOINT = 'https://api.lawfty.com';

const API_ENDPOINT = STAGING_MODE ? STAGING_ENDPOINT : PRODUCTION_ENDPOINT;

export const IS_STAGING = STAGING_MODE;
export const FORM_ENDPOINT_URL = `${API_ENDPOINT}/forms`;
export const VISITS_ENDPOINT_URL = `${API_ENDPOINT}/v1/visits`;
export const STAGING_VISITS_ENDPOINT_URL = `${STAGING_ENDPOINT}/v1/visits`;
export const PRODUCTION_VISITS_ENDPOINT_URL = `${PRODUCTION_ENDPOINT}/v1/visits`;
export const INQUIRIES_ENDPOINT_URL = `${API_ENDPOINT}/v1/inquiries`;
export const GOOGLE_REVIEWS_URL = `${API_ENDPOINT}/v1/google_reviews`;

const GEO_STAGING_URL = 'https://geo.staging-lawfty-cf.com';
const GEO_PRODUCTION_URL = 'https://geo.lawfty-cf.com';
export const GEO_ENDPOINT_URL = STAGING_MODE ? GEO_STAGING_URL : GEO_PRODUCTION_URL;

// reCAPTCHA site keys (public by design)
export const D2C_RECAPTCHA_SITE_KEY = '6LeJX9UqAAAAAAzGR3GgWO5AvXSLp2r9dhMUUbsA'; // betterleaks:allow
export const UNBOUNCE_PRODUCTION_RECAPTCHA_SITE_KEY = '6LfRiEMpAAAAAC2L80765ZZNAkGR3pVYfTJZYr1w'; // betterleaks:allow
export const UNBOUNCE_STAGING_RECAPTCHA_SITE_KEY = '6LfVkEMpAAAAAJBxp3FWze6ugOkyAxDRSWQvFq-O'; // betterleaks:allow

export const BASIC_AUTH = 'Basic ' + btoa('staging:w4afn4hj5fs3');

export const GOOGLE_REVIEW_LINKS = {
  DC: 'https://www.google.com/search?sca_esv=45c8bf4228d081b3&hl=en-US&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-Ey7HMBX38u-55mzhUhY2RfVFvc9vaxGC21VwXbyDL0Y86lxBaWFxTWD1CN83jos67AlLW3IyX7a6mfozDRgvCh0x0tqc&q=Lawfty+Reviews&sa=X&ved=2ahUKEwjv4ZaHueyNAxVMkYkEHWytB_AQ0bkNegQIIhAE&biw=1442&bih=742&dpr=2',
  NY: 'https://www.google.com/search?sca_esv=a5f19cfa0813df82&hl=en-US&gl=us&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E2jbdw03xmTbUpKIFlK-X-hMu6TYcOq01WhIlqZhWDqgdmdkIDKBtZEzW25lp6HlPOQi9eAC7rj9dLTuFL2niny4PPVW&q=Lawfty+Reviews&sa=X&ved=2ahUKEwiGyOWAueyNAxVyv4kEHb-xNA0Q0bkNegQIJRAE&biw=1442&bih=742&dpr=2',
};
export const DC_LOCATION_ID = '11142095765536388903';

const currentPath = window.location.pathname;
export const language: Language = currentPath.startsWith('/es/') || currentPath === '/es' ? 'spanish' : 'english';
// e.g. /es/practice-areas/assault -> 'assault'
export const practiceArea = currentPath.match(/^(?:\/es)?\/practice-areas\/([^/]+)/)?.[1] || null;

export const PROPERTY = 'D2C';
